<template>
    <section class="trailing">
        <DsDropdown
            class="decision-diamond-card-menu"
            data-qa="decision-diamond-card-menu-dropdown"
        >
            <template #default>
                <DsIconButton
                    data-qa="template-actions-card-menu-btn"
                    class="dropdown-button"
                    name="more-horizontal"
                />
            </template>

            <template #menu>
                <ul class="dropdown-menu-list">
                    <li
                        class="option dropdown-menu-item"
                        data-qa="import-rules"
                        @click="$emit('import-rules-from-menu')"
                    >
                        <DsIcon name="arrow-long-right" class="icon-menu-item" />
                        {{ $t('funnel.edit.decision.menu.item.import') }}
                    </li>
                    <li
                        class="option dropdown-menu-item"
                        data-qa="delete-all"
                        @click="$emit('delete-all-menu')"
                    >
                        <DsIcon name="trash-2" class="icon-menu-item" />
                        {{ $t('funnel.edit.decision.menu.item.delete') }}
                    </li>
                </ul>
            </template>
        </DsDropdown>
    </section>
</template>
<script>
export default {
    emits: ['import-rules-from-menu', 'delete-all-menu'],
};
</script>

<style lang="scss" scoped>
    .trailing {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-right: $spacing-150;
    }
    .icon-menu-item {
        margin-right: $spacing-200;
    }
</style>
